module.exports = __webpack_public_path__ + "img/xrfl_title.ec288079.webp";